// src/components/common/StarRating.jsx
import React, { useState } from 'react';

const StarRating = ({ value = 0, onChange, readonly = false, size = 'medium' }) => {
  const [hoverValue, setHoverValue] = useState(0);
  
  // Size classes
  const sizeClasses = {
    small: 'star-rating-small',
    medium: 'star-rating-medium',
    large: 'star-rating-large'
  };
  
  // Handle mouse enter
  const handleMouseEnter = (index) => {
    if (readonly) return;
    setHoverValue(index);
  };
  
  // Handle mouse leave
  const handleMouseLeave = () => {
    if (readonly) return;
    setHoverValue(0);
  };
  
  // Handle click
  const handleClick = (index) => {
    if (readonly) return;
    onChange(index);
  };
  
  // Create stars array
  const stars = [];
  for (let i = 1; i <= 5; i++) {
    let starClass = 'star-empty';
    
    if (hoverValue >= i) {
      starClass = 'star-hover';
    } else if (value >= i) {
      starClass = 'star-filled';
    } else if (value >= i - 0.5) {
      starClass = 'star-half';
    }
    
    stars.push(
      <span
        key={i}
        className={`star ${starClass}`}
        onMouseEnter={() => handleMouseEnter(i)}
        onMouseLeave={handleMouseLeave}
        onClick={() => handleClick(i)}
      >
        {starClass === 'star-half' ? (
          <span className="star-half-container">
            <span className="star-outline">★</span>
            <span className="star-half-filled">★</span>
          </span>
        ) : (
          '★'
        )}
      </span>
    );
  }
  
  return (
    <div className={`star-rating ${sizeClasses[size]} ${readonly ? 'readonly' : 'interactive'}`}>
      {stars}
    </div>
  );
};

export default StarRating;